import React from "react";
import Rose from "../../components/Typography/Rose";


export class VideoTopic extends React.Component {


	constructor(props) {
		super(props);
		this.state = {
			// series_id: this.props.data.series_id,
			series_name: this.props.data.seriesTitle,
			link_href: "/mockingbird/" + this.props.data.seriesId
		};

	}


	render() {
		return (
			<h4>
				<Rose>
					<a href={this.state.link_href}>{this.state.series_name}</a>
				</Rose>
			</h4>
		)
	}

}
